import { render, staticRenderFns } from "./ExchangeRule.vue?vue&type=template&id=5787a37b"
import script from "./ExchangeRule.vue?vue&type=script&lang=js"
export * from "./ExchangeRule.vue?vue&type=script&lang=js"
import style0 from "./ExchangeRule.vue?vue&type=style&index=0&id=5787a37b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports